<template>
  <div>
    <b-sidebar
        id="sidebar-right"
        v-model="sidebarModel"
        backdrop
        bg-variant="white"
        class="sidebar__width"
        right
        shadow
        @hidden="$emit('hideSidebar')"
    >
      <div class="mt-1 p-2">
        <h5 class="text-muted">
          {{ $t('sla.problem_type') }}
        </h5>
        <h4>{{ GET_LIST_APPEAL_SIDEBAR.problem_type }}</h4>

        <div class="mt-2">
          <h5 class="text-muted">
            {{ $t('sla.comment') }}
          </h5>

          <h4>{{ GET_LIST_APPEAL_SIDEBAR.comment }}</h4>

          <div class="mt-2">
            <b-img
                v-if="GET_LIST_APPEAL_SIDEBAR.file"
                :src="GET_LIST_APPEAL_SIDEBAR.file"
                class="sidebar__image mr-1 mb-1"
                @click="lightBox = true"
            />

            <div class="mt-2">
              <h5 class="text-muted">
                {{$t('sla.link')}}
              </h5>
              <b-link>{{ GET_LIST_APPEAL_SIDEBAR.url }}</b-link>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-center mt-3">
            <h5 class="mb-0">
              {{$t('task_manager.priority')}}
            </h5>

            <b-badge :variant="GET_LIST_APPEAL_SIDEBAR.priority.color">
              {{ GET_LIST_APPEAL_SIDEBAR.priority.title }}
            </b-badge>
          </div>

          <div class="d-flex justify-content-between align-items-center mt-1">
            <h5 class="mb-0">
              {{$t('status')}}
            </h5>

            <b-badge :variant="GET_LIST_APPEAL_SIDEBAR.status.color">
              {{ GET_LIST_APPEAL_SIDEBAR.status.title }}
            </b-badge>
          </div>

          <div v-if="GET_LIST_APPEAL_SIDEBAR.synchronized_time"
               class="d-flex justify-content-between align-items-center mt-1"
          >
            <h5 class="mb-0">
              {{ $t('sla.date_sync') }}
            </h5>

            <span>{{ GET_LIST_APPEAL_SIDEBAR.synchronized_time }}</span>
          </div>
        </div>
        <hr>

        <b-button
            class="sidebar__close__button"
            variant="danger"
            @click="sidebarModel = false"
        >
          {{$t('sla.close')}}
        </b-button>
      </div>
    </b-sidebar>

    <div
        v-show="this.lightBox"
        class="lightBox__head"
        tabindex="0"
        @click="lightBox = false"
        @keyup.esc="lightBox = false"
    >
      <div
          class="closeIcon"
          @click="lightBox = false"
      >
        <feather-icon
            class="text-white"
            icon="XIcon"
            size="22"
        />
      </div>

      <b-img
          :src="GET_LIST_APPEAL_SIDEBAR.file"
          @click="stopPropagation"
      />
    </div>
  </div>
</template>

<script>
import { BBadge, BButton, BImg, BLink, BSidebar } from 'bootstrap-vue'
import { mapGetters } from 'vuex'

export default {
  props: {
    sidebar: {
      type: [Number, Boolean],
      default: null
    }
  },
  name: 'Sidebar',
  data() {
    return {
      lightBox: false,
      sidebarModel: false,
      file: [],
    }
  },
  components: {
    BSidebar,
    BButton,
    BBadge,
    BImg,
    BLink
  },
  methods: {
    stopPropagation(event) {
      event.stopPropagation()
    }
  },
  computed: {
    ...mapGetters('listAppeal', ['GET_LIST_APPEAL_SIDEBAR']),
  },
  watch: {
    sidebar() {
      if (this.sidebar) {
        this.sidebarModel = true
      }
    },
  }
}
</script>

<style>
.sidebar__width .b-sidebar {
  width: 500px;
}

.sidebar__close__button {
  position: absolute;
  bottom: 25px;
}

.sidebar__image {
  height: 100px;
  width: auto;
  object-fit: cover;
  cursor: pointer;
  border-radius: 3px;
}

/*///////code start lightbox /////*/
.lightBox__head {
  position: fixed;
  top: 0;
  background-color: rgba(0, 0, 0, 0.56);
  height: 100vh;
  width: 100%;
  left: 0;
  z-index: 9999;
}

.lightBox__head img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 90%;
  width: auto;
  object-fit: cover;
}

.closeIcon {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
  z-index: 99;
  padding: 10px;
  background-color: rgba(34, 41, 47, 0.55);
}
</style>
